import { isNil } from "lodash-es";

import AppCounterChip, { AppCounterChipProps } from "../../Chip/AppCounterChip";
import AppTooltip, { AppTooltipProps } from "../../Tooltip/AppTooltip";

interface Props extends Omit<AppCounterChipProps, "children"> {
  count: number | null | undefined;
  /** Show if undefined, null or 0. */
  isShowEmpty?: boolean;
  tooltipProps?: Omit<AppTooltipProps, "children">;
}

export function ChatMessageCounterChip({
  count,
  isShowEmpty = false,
  size = "small",
  tooltipProps,
  ...otherProps
}: Props) {
  if ((isNil(count) || count == 0) && !isShowEmpty) {
    return null;
  }

  return (
    <AppTooltip
      {...tooltipProps}
      isEnabled={tooltipProps?.isEnabled ?? !!tooltipProps}
      title={tooltipProps?.title ?? ""}
    >
      <AppCounterChip
        {...otherProps}
        variant={(count ?? 0) > 0 ? "filled" : "outlined"}
        color={(count ?? 0) > 0 ? "secondary" : "default"}
        size={size}
        shape='round'
        count={count ?? 0}
      />
    </AppTooltip>
  );
}
